interface GoogleConfig {
  API_KEY: string;
  CLIENT_ID: string;
  SECRET: string;
}

interface FacebookConfig {
  APP_ID: string;
}

interface ApiConfig {
  API_URL: string;
}

interface Config {
  google: GoogleConfig;
  facebook: FacebookConfig;
  api: ApiConfig;
}

const config: Config = {
  google: {
    API_KEY: "",
    CLIENT_ID: "YOUR_GOOGLE_CLIENT_ID.apps.googleusercontent.com",
    SECRET: "",
  },
  facebook: {
    APP_ID: "",
  },
  api: {
    // IMPORTANT: API calls go to api.atoscloud.app with X-Tenant-Subdomain header
    // The subdomain is extracted from window.location.hostname and sent as a header
    // Example: User at promedico.atoscloud.app → Calls api.atoscloud.app with X-Tenant-Subdomain: promedico
    API_URL: process.env.REACT_APP_API_URL ||
             (process.env.NODE_ENV === 'production'
               ? 'https://api.atoscloud.app' // Centralized API endpoint
               : `http://localhost:5000`), // Development
  },
};

console.log('🔧 CONFIG.TS - Hostname:', window.location.hostname);
console.log('🔧 CONFIG.TS - API_URL:', config.api.API_URL);

export default config;
